import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { isDefined } from '@fi-shared/utils';
import { Subject } from 'rxjs';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiValuesComparison } from '@fi-shared/utils/fi-values-comparison';

@Component({
    selector: 'fi-brand-editor-site-name-editor-dialog',
    template: `
        <mat-form-field appearance="outline">
            <mat-label>{{ 'site_design.brand_name' | fiAppText }}</mat-label>
            <input matInput required [(ngModel)]="data" #brandNameModel="ngModel" />
            <mat-error
                [fiErrorMessage]="brandNameModel"
                [fiErrorCustomMessages]="{ required: 'common_error.enter_name' }"
            ></mat-error>
        </mat-form-field>
    `,
    styleUrls: ['./fi-brand-editor-site-name-editor-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-brand-editor-site-name-editor-dialog' },
    standalone: false,
})
export class FiBrandEditorSiteNameEditorDialogComponent
    extends FiDialogsContentBase<string, string>
    implements OnInit, OnDestroy
{
    private fiDialogsService: FiDialogsService;
    fiValuesComparison: FiValuesComparison<string>;

    ngOnInit() {
        this.setServices();
        this.fiValuesComparison = new FiValuesComparison(() => this.data);
        this.subscribeOnTransitionCloseDialog(this.fiDialogsService, this.ngOnDestroy$);
    }

    isYesButtonDisabled(): boolean {
        return !isDefined(this.data) || this.data.trim().length === 0;
    }

    getResult(): string {
        return this.data;
    }

    private setServices() {
        this.fiDialogsService = this.injector.get(FiDialogsService);
    }

    getNoButtonClickPromise(): Promise<{ canClose: boolean }> {
        return this.fiDialogsService.getCanCloseConfirmation(!this.fiValuesComparison.isChanged());
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
